var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6845 8.99945C11.6845 10.4845 10.4845 11.6845 8.99945 11.6845C7.51445 11.6845 6.31445 10.4845 6.31445 8.99945C6.31445 7.51445 7.51445 6.31445 8.99945 6.31445C10.4845 6.31445 11.6845 7.51445 11.6845 8.99945Z",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99891 15.2035C11.6464 15.2035 14.1139 13.6435 15.8314 10.9435C16.5064 9.88602 16.5064 8.10852 15.8314 7.05102C14.1139 4.35102 11.6464 2.79102 8.99891 2.79102C6.35141 2.79102 3.88391 4.35102 2.16641 7.05102C1.49141 8.10852 1.49141 9.88602 2.16641 10.9435C3.88391 13.6435 6.35141 15.2035 8.99891 15.2035Z",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIcon);
export default __webpack_public_path__ + "static/media/password_icon.52f44b31ff817da81bce4b5462bf2687.svg";
export { ForwardRef as ReactComponent };